export enum EnumTargetSLOType {
    NUMERIC = 'NUMERIC',
    TEXTUAL = 'TEXTUAL',
    PERCENT = 'PERCENT'
}
